import { CSSProperties } from 'react';

interface Props {
  size?: string;
  style?: CSSProperties;
}
export const MarkerIcon = ({ size, ...args }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size || '32'}
      height={size || '32'}
      viewBox="0 0 32 32"
      {...args}
    >
      <defs>
        <clipPath id="MapMarker">
          <rect
            id="사각형_3216"
            data-name="사각형 3216"
            width="32"
            height="32"
            transform="translate(1147 9004)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        id="마스크_그룹_201"
        data-name="마스크 그룹 201"
        transform="translate(-1147 -9004)"
        clipPath="url(MapMarker)"
      >
        <g id="mapmarker" transform="translate(1147 9004)">
          <g id="Layer_2_00000069358518310060244730000014047456146431823776_">
            <g id="Layer_1-2">
              <g id="Page-1">
                <g id="map">
                  <path
                    id="패스_2370"
                    data-name="패스 2370"
                    d="M0,0V32H32V0ZM16,7.273a4.364,4.364,0,1,1-4.364,4.364A4.376,4.376,0,0,1,16,7.273Z"
                    fill="rgba(216,216,216,0)"
                    fillRule="evenodd"
                  />
                  <g id="地图" transform="translate(5.164 0.727)">
                    <g id="Group">
                      <g id="Clipped">
                        <g id="그룹_4325" data-name="그룹 4325">
                          <path
                            id="Shape"
                            d="M13.652.386H13.58A10.817,10.817,0,0,0,2.743,11.223V11.3c0,6.327,5.455,14.255,9.382,18.836a2.164,2.164,0,0,0,1.455.727h.073a2.164,2.164,0,0,0,1.455-.727c3.927-4.582,9.309-12.509,9.309-18.836A10.816,10.816,0,0,0,13.652.386ZM13.58,15.659A4.364,4.364,0,1,1,17.943,11.3,4.376,4.376,0,0,1,13.58,15.659Z"
                            transform="translate(-2.743 -0.386)"
                            fill="#ff3141"
                            fillRule="evenodd"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <path
            id="패스_2371"
            data-name="패스 2371"
            d="M10.545,3.864a4.364,4.364,0,1,0,4.364,4.364A4.376,4.376,0,0,0,10.545,3.864Zm0,8.727a4.364,4.364,0,1,1,4.364-4.364A4.376,4.376,0,0,1,10.545,12.591Z"
            transform="translate(5.455 3.409)"
            fill="#4a4a4a"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};
